import moment from "moment";
import * as types from "../constants/ActionTypes";

//####### NOVA FUNÇÃO PARA TRATAR ATENDIMENTOS SIMULTÂNEO #############
const atdsimult = (state = [], action) => {
  switch (action.type) {
    case types.ATD_SIMULT:
      const hasThisAtd = !!state.some(
        (atd) => parseInt(atd.idatendimento) === parseInt(action.idatendimento)
      );
      if (!hasThisAtd) {
        return [
          ...state,
          {
            idatendimento: action.idatendimento,
            cliente: action.cliente,
            telefone: action.telefone,
            servico: action.servico,
            datatimeatd: action.datatimeatd,
            menubot: action.menubot,
            criticidade: action.criticidade,
            subservico: action.subservico,
            id: action.id,
            serviceatd: action.serviceatd,
            recuperation: action.recuperation,
            recuperationtime: action.recuperationtime,
            respatendente: action.respatendente,
            respclient: action.respclient,
            direction: action.direction,
            idmidia: action.idmidia,
            timecomplete: action.timecomplete,
            statusagent: action.statusagent,
            line: action.line,
            statusatd: 0,
            queueid: action.queueid,
            serverid: action.serverid,
            qtdmessage: action.qtdmessage, // VER AQUI
            pathfile: action.pathfile,
            mtnow: action.mtnow,
            msg: "",
            mcdu: action.mcdu,
            nomesubservico: action.nomesubservico,
            infoinitcall: action.infoinitcall,
            nomecliente: action.nomecliente,
            protocolo: action.protocolo,
            datatachado:
              state.datatachado !== undefined ? state.datatachado : "",
            idsubservico: action.idsubservico,
            acw: action.acw,
            isDialNc2: action.isDialNc2,
            arrayChannels:
              action.arrayChannels !== undefined ? action.arrayChannels : [],
            score_class: action.score_class,
            score_value: action.score_value,
            nps_call: action.nps_call,
          },
        ];
      } else {
        return state;
      }

    case types.ATD_DEL:
      return state.filter(
        (atd) => parseInt(atd.idatendimento) !== parseInt(action.idatendimento)
      );
    case "EDIT_MULTIPLES":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? { ...atd, statusatd: action.statusatd }
          : atd
      );
    case "EDIT_MULTIPLES_VOZ":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? { ...atd, recuperationtime: action.recuperationtime }
          : atd
      );
    case "EDIT_MENU_BOT":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? { ...atd, protocolo: action.protocolo }
          : atd
      );
    case "EDIT_MENU_BOT_DATA":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? { ...atd, datatachado: action.datatachado }
          : atd
      );

    case "EDIT_SURVEY":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? {
              ...atd,
              score_class: action.score_class,
              score_value: action.score_value,
            }
          : atd
      );

    case "EDIT_ATD_SIMULT":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? {
              ...atd,
              idatendimento: action.idatendimento,
              cliente: action.cliente,
              telefone: action.telefone,
              servico: action.servico,
              datatimeatd: action.datatimeatd,
              menubot: action.menubot,
              criticidade: action.criticidade,
              subservico: action.subservico,
              serviceatd: action.serviceatd,
              recuperation: action.recuperation,
              recuperationtime: action.recuperationtime,
              respatendente: action.respatendente,
              respclient: action.respclient,
              direction: action.direction,
              idmidia: action.idmidia,
              timecomplete: action.timecomplete,
              statusagent: action.statusagent,
              line: action.line,
              statusatd: action.statusatd,
              serverid: action.serverid,
              qtdmessage: action.qtdmessage,
              pathfile: action.pathfile,
              infoinitcall: action.infoinitcall,
              protocolo: action.protocolo,
              datatachado:
                state.datatachado !== undefined ? state.datatachado : "",
              score_class: action.score_class,
              score_value: action.score_value,
              nps_call: action.nps_call,
            }
          : atd
      );
    case "EDIT_QTD_MSG":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? { ...atd, qtdmessage: atd.qtdmessage + 1 }
          : atd
      );
    case "EDITMSG":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.id)
          ? { ...atd, msg: action.msg }
          : atd
      );
    case "CLEAR_QTD_MSG":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? { ...atd, qtdmessage: 0 }
          : atd
      );
    case "EDIT_INFO_CLI":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.id)
          ? {
              ...atd,
              cliente: action.name,
              menubot: action.arraymenubot,
              nomesubservico: action.nomesubservico
                ? action.nomesubservico
                : atd.nomesubservico,
            }
          : atd
      );
    case "EDIT_SUBJECT_MAIL":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.id)
          ? {
              ...atd,
              nomesubservico: action.nomesubservico,
              servico: action.nomesubservico,
              cliente: action.nomesubservico,
            }
          : atd
      );
    case "EDIT_NUMBERS_DISPONIBLES_CHANNEL":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? { ...atd, arrayChannels: action.arrayChannels }
          : atd
      );
    case "EDIT_ID_SERVICEATD":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.idatendimento)
          ? { ...atd, serviceatd: action.retornoatt }
          : atd
      );
    case "EDIT_ACW_CONTACT":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? { ...atd, acw: true, hourAcw: moment() }
          : atd
      );
    case "EDIT_IS_TABULATION":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              isTabulation:
                atd.isTabulation === true
                  ? atd.isTabulation
                  : action.isTabulation,
            }
          : atd
      );
    case "EDIT_ACW_CONTACT_DISABLED":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? { ...atd, acw: true }
          : atd
      );
    case "CHANGE_IS_INGDESK":
      return state.map((atd) =>
        parseInt(atd.telefone) === parseInt(action.telefone)
          ? {
              ...atd,
              isInteractionIngDesk: true,
              clientId: action.clientId,
              clientName: action.clientName,
              caseId: action.caseId,
            }
          : atd
      );
    case "EDIT_CLIENT_NAME":
      return state.map((atd) => {
        const findNumber = action.telefones.find(
          (number) => number.number.includes(atd.telefone)
          // parseInt(atd.telefone) === parseInt(number.number)
        );

        if (findNumber) {
          return {
            ...atd,
            cliente: action.clientName,
          };
        } else {
          return atd;
        }
      });
    case "ADD_ENTERPRISE_ADDITIONAL_INFOS":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              enterpriseAdditionalInfos: action.enterpriseAdditionalInfos,
            }
          : atd
      );
      break;
    case "ADD_CONTACT_ADDITIONAL_INFOS":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              contactAdditionalInfos: action.contactAdditionalInfos,
            }
          : atd
      );
      break;
    case "CHANGE_LAST_CDR_CLICKED":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              lastCdrClicked: action.lastCdrClicked,
            }
          : atd
      );
    case "CLEAR_ATD_SIMULT_ALL":
      console.log("INGENIUM_INITIALLOGIN");
      return [];
    case "CLEAR_ATD_ALL":
      console.log("INGENIUM_INITIALLOGIN");
    default:
      return state;
  }
};

//####### ANTIGA FUNÇÃO PARA TRATAR ATENDIMENTOS SIMULTÂNEO #############

// const atdsimult = (state = [], action) => {
//   switch (action.type) {
//     case types.ATD_SIMULT:
//       return [
//         ...state,
//         {
//           idatendimento: action.idatendimento,
//           cliente: action.cliente,
//           telefone: action.telefone,
//           servico: action.servico,
//           datatimeatd: action.datatimeatd,
//           menubot: action.menubot,
//           criticidade: action.criticidade,
//           subservico: action.subservico,
//           id: action.id,
//           serviceatd: action.serviceatd,
//           recuperation: action.recuperation,
//           recuperationtime: action.recuperationtime,
//           respatendente: action.respatendente,
//           respclient: action.respclient,
//           direction: action.direction,
//           idmidia: action.idmidia,
//           timecomplete: action.timecomplete,
//           statusagent: action.statusagent,
//           line: action.line,
//           statusatd: 0,
//           queueid: action.queueid,
//           serverid: action.serverid,
//           qtdmessage: action.qtdmessage, // VER AQUI
//           pathfile: action.pathfile,
//           mtnow: action.mtnow,
//           msg: "",
//           mcdu: action.mcdu,
//           nomesubservico: action.nomesubservico,
//           infoinitcall: action.infoinitcall,
//           nomecliente: action.nomecliente,
//           protocolo: action.protocolo,
//           datatachado: state.datatachado !== undefined ? state.datatachado : "",
//           idsubservico: action.idsubservico,
//           acw: action.acw,
//           isDialNc2: action.isDialNc2,
//           arrayChannels:
//             action.arrayChannels !== undefined ? action.arrayChannels : [],
//           score_class: action.score_class,
//           score_value: action.score_value,
//           nps_call: action.nps_call,
//         },
//       ];

//     case types.ATD_DEL:
//       return state.filter(
//         (atd) => parseInt(atd.idatendimento) !== parseInt(action.idatendimento)
//       );
//     case "EDIT_MULTIPLES":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? { ...atd, statusatd: action.statusatd }
//           : atd
//       );
//     case "EDIT_MULTIPLES_VOZ":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? { ...atd, recuperationtime: action.recuperationtime }
//           : atd
//       );
//     case "EDIT_MENU_BOT":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? { ...atd, protocolo: action.protocolo }
//           : atd
//       );
//     case "EDIT_MENU_BOT_DATA":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? { ...atd, datatachado: action.datatachado }
//           : atd
//       );

//     case "EDIT_SURVEY":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? {
//               ...atd,
//               score_class: action.score_class,
//               score_value: action.score_value,
//             }
//           : atd
//       );

//     case "EDIT_ATD_SIMULT":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? {
//               ...atd,
//               idatendimento: action.idatendimento,
//               cliente: action.cliente,
//               telefone: action.telefone,
//               servico: action.servico,
//               datatimeatd: action.datatimeatd,
//               menubot: action.menubot,
//               criticidade: action.criticidade,
//               subservico: action.subservico,
//               serviceatd: action.serviceatd,
//               recuperation: action.recuperation,
//               recuperationtime: action.recuperationtime,
//               respatendente: action.respatendente,
//               respclient: action.respclient,
//               direction: action.direction,
//               idmidia: action.idmidia,
//               timecomplete: action.timecomplete,
//               statusagent: action.statusagent,
//               line: action.line,
//               statusatd: action.statusatd,
//               serverid: action.serverid,
//               qtdmessage: action.qtdmessage,
//               pathfile: action.pathfile,
//               infoinitcall: action.infoinitcall,
//               protocolo: action.protocolo,
//               datatachado:
//                 state.datatachado !== undefined ? state.datatachado : "",
//               score_class: action.score_class,
//               score_value: action.score_value,
//               nps_call: action.nps_call,
//             }
//           : atd
//       );
//     case "EDIT_QTD_MSG":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.cdr)
//           ? { ...atd, qtdmessage: atd.qtdmessage + 1 }
//           : atd
//       );
//     case "EDITMSG":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.id)
//           ? { ...atd, msg: action.msg }
//           : atd
//       );
//     case "CLEAR_QTD_MSG":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.cdr)
//           ? { ...atd, qtdmessage: 0 }
//           : atd
//       );
//     case "EDIT_INFO_CLI":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.id)
//           ? {
//               ...atd,
//               cliente: action.name,
//               menubot: action.arraymenubot,
//               nomesubservico: action.nomesubservico
//                 ? action.nomesubservico
//                 : atd.nomesubservico,
//             }
//           : atd
//       );
//     case "EDIT_SUBJECT_MAIL":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.id)
//           ? {
//               ...atd,
//               nomesubservico: action.nomesubservico,
//               servico: action.nomesubservico,
//               cliente: action.nomesubservico,
//             }
//           : atd
//       );
//     case "EDIT_NUMBERS_DISPONIBLES_CHANNEL":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? { ...atd, arrayChannels: action.arrayChannels }
//           : atd
//       );
//     case "EDIT_ID_SERVICEATD":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.idatendimento)
//           ? { ...atd, serviceatd: action.retornoatt }
//           : atd
//       );
//     case "EDIT_ACW_CONTACT":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.cdr)
//           ? { ...atd, acw: true, hourAcw: moment() }
//           : atd
//       );
//     case "EDIT_IS_TABULATION":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.cdr)
//           ? {
//               ...atd,
//               isTabulation:
//                 atd.isTabulation === true
//                   ? atd.isTabulation
//                   : action.isTabulation,
//             }
//           : atd
//       );
//     case "EDIT_ACW_CONTACT_DISABLED":
//       return state.map((atd) =>
//         parseInt(atd.idatendimento) === parseInt(action.cdr)
//           ? { ...atd, acw: true }
//           : atd
//       );
//     case "CHANGE_IS_INGDESK":
//       return state.map((atd) =>
//         parseInt(atd.telefone) === parseInt(action.telefone)
//           ? {
//               ...atd,
//               isInteractionIngDesk: true,
//               clientId: action.clientId,
//               clientName: action.clientName,
//               caseId: action.caseId,
//             }
//           : atd
//       );
//     case "EDIT_CLIENT_NAME":
//       return state.map((atd) => {
//         const findNumber = action.telefones.find(
//           (number) => number.number.includes(atd.telefone)
//           // parseInt(atd.telefone) === parseInt(number.number)
//         );

//         if (findNumber) {
//           return {
//             ...atd,
//             cliente: action.clientName,
//           };
//         } else {
//           return atd;
//         }
//       });
//     case "CLEAR_ATD_SIMULT_ALL":
//       console.log("INGENIUM_INITIALLOGIN");
//       return [];
//     case "CLEAR_ATD_ALL":
//       console.log("INGENIUM_INITIALLOGIN");
//     default:
//       return state;
//   }
// };

export default atdsimult;
